import { useState } from "react";
import AdminModal from "../../../../core/admin/adminModal";
import { useWatches } from "../../../../../context/watchProvider";
import { useAuth } from "../../../../../context/authProvider";
import { collectionHasDoc, randomGenerator } from "../../../../../utils/functions";
import AdminButton from "../../../../core/admin/adminButton";
import AdminField from "../../../../core/admin/adminField";
import AdminTextInput from "../../../../core/admin/adminTextInput";
import AdminCallout from "../../../../core/admin/adminCallout";

export default function CreateDraftModal({ close, finish }: { close: () => void, finish: () => void }) {

    const { createWatch } = useWatches();
    const { userId } = useAuth();

    const [loading, setLoading] = useState(false);
    const [errored, setErrored] = useState(false);

    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [year, setYear] = useState("");

    const handleStep1 = async (e: React.FormEvent<HTMLFormElement>) => {
        try {
            e.preventDefault();
            setLoading(true);
            if (!userId) {
                throw new Error("Autenticação necessária");
            }
            // criar um slug não utilizado ainda
            let randomStr = "";
            while (true) {
                randomStr = randomGenerator();
                const hasDoc = await collectionHasDoc("watches", "slug", randomStr);
                if (!hasDoc) {
                    break;
                }
            }
            const docId = await createWatch(userId, brand, model, parseInt(year), randomStr);
            if (!docId) {
                setLoading(false);
                setErrored(true);
                return null;
            }
            setErrored(false);
            setLoading(false);
            finish();
        } catch (error) {
            setLoading(false);
            setErrored(true);
        }
    }

    const handleYear = (value: string) => {
        if(value === ""){
            setYear("");
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        setYear(value);
    }

    return (
        <AdminModal
            close={close}
            title="Criar rascunho"
            subtitle="Dados iniciais — as demais informações e as imagens são preenchidas depois, em “Completar”."
            footer={
                <>
                    <AdminButton variant="secondary" disabled={loading} onClick={close}>Cancelar</AdminButton>
                    <AdminButton type="submit" form="create-draft-form" loading={loading} className="sm:min-w-[120px]">Criar</AdminButton>
                </>
            }
        >
            <form id="create-draft-form" onSubmit={e => handleStep1(e)} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <AdminField label="Marca" htmlFor="draft-brand">
                    <AdminTextInput id="draft-brand" value={brand} onChange={e => setBrand(e.target.value)} placeholder="Ex.: Rolex" />
                </AdminField>
                <AdminField label="Modelo" htmlFor="draft-model">
                    <AdminTextInput id="draft-model" value={model} onChange={e => setModel(e.target.value)} placeholder="Ex.: Submariner" />
                </AdminField>
                <AdminField label="Ano" htmlFor="draft-year">
                    <AdminTextInput id="draft-year" inputMode="numeric" value={year} onChange={e => handleYear(e.target.value)} placeholder="Ex.: 2020" />
                </AdminField>
            </form>
            {
                errored ?
                    <AdminCallout tone="danger" className="mt-4">Ocorreu um erro na operação</AdminCallout>
                    : null
            }
        </AdminModal>
    )
}